import { useEffect, useState } from "react";
import api from "../api/axios";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
function GrievanceList() {
const menus = JSON.parse(localStorage.getItem("menus") || "[]");
// const hasAction = (menuId, actionCode) => {
//   const menu = menus.find(x => x.menuId === menuId);

//   return menu?.actions?.some(
//     x => x.actionCode === actionCode
//   );
// };

// const hasAction = (menuId, actionCode) => {
//   const menu = menus.find(
//     x => Number(x.menuId) === Number(menuId)
//   );

//   console.log("Checking:", {
//     menuId,
//     actionCode,
//     menu,
//     actions: menu?.actions
//   });

//   return menu?.actions?.some(
//     x => x.actionCode?.toUpperCase() === actionCode.toUpperCase()
//   ) ?? false;
// };
const location = useLocation();

const currentMenu = menus.find(
  x => x.menuUrl?.toLowerCase() === location.pathname.toLowerCase()
);


const currentMenuId = currentMenu?.menuId;


const hasAction = (menuId, actionCode) => {
  const menu = menus.find(
    x => Number(x.menuId) === Number(menuId)
  );

  return menu?.actions?.some(
    x => x.actionCode === actionCode
  ) ?? false;
};

// console.log("Has ADD:", hasAction(20, "ADD"));
// console.log("Has EDIT:", hasAction(20, "EDIT"));
// console.log("Has DELETE:", hasAction(20, "DELETE"));

  const [services, setServices] = useState([]);
  const [statuses, setStatus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState({});

  
  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      setLoading(true);

      const [servicesResponse, statusResponse] = await Promise.all([
        api.get("/Grievance/GetAll"),
        api.get("/Grievance/GetStatus"),
      ]);

      setServices(servicesResponse.data || []);
      setStatus(statusResponse.data || []);

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to load data.",
      });
    } finally {
      setLoading(false);
    }
  };

  // Zone selection
const handleStatusChange = (grievanceId, statusId) => {
  setSelectedStatus((prev) => ({
    ...prev,
    [grievanceId]: statusId,
  }));
};


  const updateStatus = async (id) => {
  const statusId = selectedStatus[id];


    if (!statusId) {
    Swal.fire({
      icon: "warning",
      title: "Select Status",
      text: "Please select a status first.",
    });
    return;
  }

    // try {
    //   await api.put(`/Grievance/UpdateStatus/${id}`, {
    //     zoneId: Number(zoneId),
    //     assignedTo: Number(2),
    //     status: "Active",
    //   });
     try {
    // await api.put(`/Grievance/UpdateStatus/${id}`, {
    //   statusId: statusId,
    // });

    await api.put(`/Grievance/UpdateStatus/${id}`, {
  statusId: selectedStatus[id],
});

// ya agar API latest data return nahi karti
setSelectedStatus((prev) => ({
  ...prev,
  [id]: selectedStatus[id],
}));


      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Status Updated Successfully.",
      });

      loadServices();
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Unable to update status.",
      });
    }
  };

  const showDetails = (item, type) => {
    Swal.fire({
      //title: type === "view" ? "Grievance Details" : "Acknowledgement",
      title: type === "view" ? "Grievance Details" : "",
      width: "700px",
      html: `
      <div style="text-align:left">
        <p><b>Application No:</b> ${item.g.grievanceNo}</p>
        <p><b>Name:</b> ${item.g.name}</p>
        <p><b>Mobile:</b> ${item.g.mobileNo}</p>
        <p><b>Email:</b> ${item.g.email}</p>
        <p><b>Ward:</b> ${item.g.wardName || ""}</p>
        <p><b>Location:</b> ${item.locationName || ""}</p>
        <p><b>Grievance Type:</b> ${item.grievanceType || ""}</p>
        <p><b>Sub Type:</b> ${item.grievanceSubType || ""}</p>
        <p><b>Assigned To:</b> ${item.assignedPerson || ""}</p>
        <p><b>Status:</b> ${item.g.status || ""}</p>
        <p><b>Created Date:</b> ${item.g.createdDate || ""}</p>
      </div>
    `,
      confirmButtonText: "Close",
    });
  };

  //  <h3 style="text-align:center">Acknowledgement</h3>

  const showAckPopup = (item) => {
    const html = `
    <div id="ackPrint" style="text-align:left;font-family:Arial">
     
      <hr>

      <table style="width:100%;border-collapse:collapse">
        <tr>
          <td><b>Application No.</b></td>
          <td>${item.g.grievanceNo}</td>
        </tr>
        <tr>
          <td><b>Name</b></td>
          <td>${item.g.name}</td>
        </tr>
        <tr>
          <td><b>Mobile</b></td>
          <td>${item.g.mobileNo}</td>
        </tr>
        <tr>
          <td><b>Email</b></td>
          <td>${item.g.email}</td>
        </tr>
        <tr>
          <td><b>Ward</b></td>
          <td>${item.g.wardName}</td>
        </tr>
        <tr>
          <td><b>Location</b></td>
          <td>${item.locationName}</td>
        </tr>
        <tr>
          <td><b>Grievance Type</b></td>
          <td>${item.grievanceType}</td>
        </tr>
        <tr>
          <td><b>Sub Type</b></td>
          <td>${item.grievanceSubType}</td>
        </tr>
        <tr>
          <td><b>Created Date</b></td>
          <td>${new Date(item.g.createdDate).toLocaleDateString("en-GB")}
          ${(() => {
            const date = new Date(item.g.createdDate);
            date.setDate(date.getDate() + 1);
            return date.toLocaleString("en-GB");
          })()}
          </td>
        </tr>
      </table>
    </div>
  `;

    Swal.fire({
      title: "Acknowledgement",
      html,
      width: 700,
      showCancelButton: true,
      confirmButtonText: "Print",
      cancelButtonText: "Close",
    }).then((result) => {
      if (result.isConfirmed) {
        printAcknowledgement(html);
      }
    });
  };

  const printAcknowledgement = (html) => {
    const printWindow = window.open("", "", "width=900,height=700");

    printWindow.document.write(`
    <html>
      <head>
        <title>Acknowledgement</title>
        <style>
          body{
            font-family:Arial;
            padding:20px;
          }
          table{
            width:100%;
            border-collapse:collapse;
          }
          td{
            border:1px solid #000;
            padding:8px;
          }
          h3{
            text-align:center;
          }
        </style>
      </head>
      <body>
        ${html}
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  return (
    <div className="container-fluid mt-3">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">View Grievances</h5>
        </div>

        <div className="card-body">
          {loading ? (
            <div className="text-center">
              <h5>Loading...</h5>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>ID</th>
                    <th>App No.</th>
                    <th>User Information</th>
                    {/* <th>Zone</th> */}
                    <th>Request Location</th>
                    {/* <th>Location</th> */}
                    {/* <th>Address</th> */}
                    <th>Grievance Type</th>
                    <th>Sub Type</th>
                    <th>Created/Expiry Date</th>
                    <th>Assigned To</th>
                    <th>View/Ack</th>
                    <th>Status</th>
                    <th>User</th>
                  </tr>
                </thead>

                <tbody>
                  {services.length > 0 ? (
                    services.map((item) => (
                      <tr key={item.id}>
                        <td>{item.g.id}</td>

                        <td>{item.g.grievanceNo}</td>

                        <td>
                          <strong>{item.g.name}</strong>
                          <br />
                          {item.g.mobileNo}
                          <br />
                          {item.g.email}
                        </td>

                        {/* <td>{item.zoneName || item.zoneId}</td> */}

                        <td>
                          {item.wardName || item.wardId}
                          <br></br>

                          {item.locationName || item.locationId}
                        </td>

                        {/* <td>{item.address}</td> */}

                        <td>{item.grievanceType || item.grievanceTypeId}</td>

                        <td>{item.grievanceSubType || item.subTypeId}</td>

                        <td>
                          <span className="badge bg-success">
                            {new Date(item.g.createdDate).toLocaleDateString(
                              "en-GB",
                            )}
                          </span>
                          <br></br>
                          <span className="badge bg-danger">
                            {(() => {
                              const date = new Date(item.g.createdDate);
                              date.setDate(date.getDate() + 7);
                              return date.toLocaleDateString("en-GB");
                            })()}
                          </span>
                        </td>

                        <td>{item.assignedPerson}</td>
                        <td style={{ minWidth: "70px" }}>
                          <button
                            className="btn btn-link p-0 me-2"
                            onClick={() => showDetails(item, "view")}
                          >
                            <i className="bi bi-file-text fs-5"></i>
                          </button>

                          {/* <button
    className="btn btn-link p-0 btn-sm"
    onClick={() => showDetails(item, "ack")}
  >
    <i className="bi bi-file-earmark-check-fill fs-5 text-success"></i>
  </button> */}

                          <button
                            className="btn btn-link p-0"
                            onClick={() => showAckPopup(item)}
                          >
                            <i className="bi bi-file-earmark-check-fill fs-5 text-success"></i>
                          </button>
                        </td>
                        <td style={{ minWidth: "120px" }}>

{
  (() => {
    const createdDate = new Date(item.g.createdDate);
    const today = new Date();

    const diffDays = Math.floor(
      (today - createdDate) / (1000 * 60 * 60 * 24)
    );

    if (diffDays > 7) {
      return <span className="text-danger">{item.g.griStatus} <br></br>Status Changes Closed</span>;
    } else {
      const dueDate = new Date(createdDate);
      dueDate.setDate(dueDate.getDate() + 7);
      return (
        <>
          {/* {dueDate.toLocaleDateString("en-GB")} badge bg-danger*/}

          
                          
<select
  className="form-select mb-2"
  value={selectedStatus[item.g.id] ?? item.g.griStatus ?? ""}
  onChange={(e) => handleStatusChange(item.g.id, e.target.value)}
>
  <option value="">Select Status</option>

  {statuses.map((status) => (
    <option key={status.id} value={status.id}>
      {status.statusName}
    </option>
  ))}
</select>

<button
  className="btn btn-success btn-sm w-100"
  onClick={() => updateStatus(item.g.id)}
  disabled={!selectedStatus[item.g.id]}
>
  Update Status
</button>
{hasAction(currentMenuId, "ADD") && (
  <button>Add</button>
)}

{hasAction(currentMenuId, "EDIT") && (
  <button>Edit</button>
)}

{hasAction(currentMenuId, "DELETE") && (
  <button>Delete</button>
)}


        </>
      );
    }
  })()
}


                        </td>

                        <td>{item.g.user}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="13" className="text-center">
                        No Record Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default GrievanceList;
